<div class="mother-shipper">
  <div>
    <label class="secondary-details">{{
      'configuration.motherShipperList.motherShipperList' | translate
    }}</label>
    <button
      type="submit"
      class="primary-btn float-right mt-2"
      (click)="openEditorCreatePopup('', '', 'Create')">
      {{ 'global.create' | translate }}
    </button>
  </div>
  <div class="custom-card">
    <div class="col-12 table-container">
      <table mat-table aria-describedby="mother-shipper" [dataSource]="motherShipperData" matSort>
        <ng-container matColumnDef="nickName">
          <th id="nickName" mat-header-cell *matHeaderCellDef>
            {{ 'configuration.motherShipperList.nickName' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.shipperNickName }}</td>
        </ng-container>
        <ng-container matColumnDef="shipperCompanyName">
          <th id="shipperCompanyName" mat-header-cell *matHeaderCellDef>
            {{ 'configuration.motherShipperList.shipperCompanyName' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.shipperCompanyName }}</td>
        </ng-container>

        <ng-container matColumnDef="shipperContactPersonName">
          <th id="shipperContactPersonName" mat-header-cell *matHeaderCellDef>
            {{ 'configuration.motherShipperList.shipperContactPersonName' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.shipperContactPersonName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="shipperCountryName">
          <th id="shipperCountryName" mat-header-cell *matHeaderCellDef>
            {{ 'configuration.motherShipperList.shipperCountryName' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.shipperCountryName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="shipperCountryCode">
          <th id="shipperCountryCode" mat-header-cell *matHeaderCellDef>
            {{ 'configuration.motherShipperList.shipperCountryCode' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.shipperCountryCode }}
          </td>
        </ng-container>
        <ng-container *ngIf="isLbx" matColumnDef="isDefault">
          <th id="isDefault" mat-header-cell *matHeaderCellDef>
            {{ 'configuration.motherShipperList.lbxDefault' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.isDefault ? 'Yes' : 'No' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th id="action" mat-header-cell *matHeaderCellDef>{{ 'global.action' | translate }}</th>
          <td mat-cell *matCellDef="let element; let index = index">
            <i
              matTooltip="{{ 'configuration.motherShipperList.toolTip.edit' | translate }}"
              class="m-1 icon-mat bi bi-pen"
              (click)="openEditorCreatePopup(element, index, 'Edit')"></i>
            <i
              matTooltip="{{ 'configuration.motherShipperList.toolTip.delete' | translate }}"
              class="m-1 icon-mat bi bi-trash"
              (click)="deleteShipperAddress(element)"></i>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row justify-content-center" *matNoDataRow>
          {{
            'global.noDataAvailable' | translate
          }}
        </tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons> </mat-paginator>
    </div>
  </div>
</div>
